module.exports = __webpack_public_path__ + "static/media/ex6.38c4956d.jpg";